import * as React from 'react';
import 'antd/dist/antd.css';
// import Icon from '@ant-design/icons';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

/**
 * @export
 * @interface HorizontalCollapseProps
 * @extends {React.HTMLAttributes<HTMLDivElement>}
 */
export interface BaseProps {
    // L'amplada del component un cop expandit
    expandedWidth: number | string;

    // Per controlar el estat de 'expanded' des de fora
    expanded?: boolean

    // Per controlar si el control està obert inicialment o no quan no es controla des de fora. Per defecte és false.
    initiallyExpanded?: boolean;

    // Si es true sèxpandirà cap a l'esquerra, per tant els símbol '<' i '>' s'han de canviar
    expandToLeft?: boolean;

    // Callback per rebre l'estat del Collapse. true si està expandit i false si està col·lapsat
    onToggleExpanded?: (expanded: boolean) => void;

    // Text que sortirà al costat del símbol > o <
    text?: string;
}

interface HorizontalCollapseState {
    expanded: boolean;
}

export type HorizontalCollapseProps = BaseProps & React.HTMLAttributes<HTMLDivElement>;

/**
 * Class representing the HorizontalCollapse.
 *
 * @class HorizontalCollapse
 * @extends React.Component
 */
export class HorizontalCollapse extends React.Component<HorizontalCollapseProps, HorizontalCollapseState> {

    /**
     * Creates the HorizontalCollapse.
     *
     * @constructs HorizontalCollapse
     */
    constructor(props: HorizontalCollapseProps) {
        super(props);
        const controlled = !(props.expanded === undefined);
        this.state = {
            expanded: controlled ? props.expanded : props.initiallyExpanded
        };
    }

    // Canvia el estat de collapsed entre obert i tancat
    toogleExpanded = () => {
        const newExpanded = (this.props.expanded === undefined) ? !this.state.expanded : !this.props.expanded;
        this.setState({ expanded: newExpanded });
        // Cridar a la funció amb el paràmetre exp
        if (this.props.onToggleExpanded) {
            this.props.onToggleExpanded(newExpanded);
        }
    }

    /**
     * The render function.
     */
    render() {
        const {
            expandedWidth,
            expanded,
            // initiallyExpanded,
            expandToLeft,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            onToggleExpanded,
            // text,
            ...passThroughProps
        } = this.props;

        // Si hi ha la propietat expanded, la fem servir, si no fem servir el state intern
        const isExpanded: boolean = expanded === undefined ? this.state.expanded : expanded;

        return (
            <div
                className="ant-collapse ant-collapse-icon-position-left"
                {...passThroughProps}
            >
                <div className="ant-collapse-item" style={{ display: 'inline-flex', width: isExpanded ? expandedWidth : 'auto', cursor: 'pointer' }}>
                    <div role="button" aria-expanded="false" style={{ padding: '5px' }}  onClick={this.toogleExpanded} >
                        {!!this.props.text && !isExpanded && !expandToLeft && <span>{this.props.text}&nbsp;</span>}
                        {((isExpanded && !expandToLeft) || (!isExpanded && expandToLeft)) && <LeftOutlined style={{fontSize: '12px'}}/>}
                        {!((isExpanded && !expandToLeft) || (!isExpanded && expandToLeft)) && <RightOutlined style={{fontSize: '12px'}}/>}
                        {!!this.props.text && !isExpanded && expandToLeft && <span>&nbsp;{this.props.text}</span>}
                    </div>
                    <div style={{display: isExpanded ? 'block' : 'none', width: '100%'}}>
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

export default HorizontalCollapse;